import type { KeyboardEvent } from "react";

import type { AttachmentCreate } from "~/entities/chat";
import type { PendingUpload } from "~/shared/store/types";

/**
 * Преобразует загруженные pending-файлы в attachment-payload для отправки:
 * берём только полностью залитые (status "done" + наличие s3Key), маппим в
 * `AttachmentCreate` со статусом "uploaded".
 */
export function buildAttachmentsToSend(items: readonly PendingUpload[]): AttachmentCreate[] {
    return items
        .filter((item) => item.status === "done" && item.s3Key)
        .map((item) => ({
            s3Key: item.s3Key!,
            kind: item.kind,
            mimeType: item.mimeType,
            sizeBytes: item.sizeBytes,
            status: "uploaded",
            sha256: item.sha256,
        }));
}

/**
 * Enter без Shift и без IME-композиции = отправка промпта (Shift+Enter — перенос
 * строки, во время композиции иероглифов Enter подтверждает кандидата, не сабмит).
 */
export function isEnterSubmit(event: KeyboardEvent): boolean {
    return event.key === "Enter" && !event.shiftKey && !event.nativeEvent.isComposing;
}
